




































































import {Component, Vue, Watch} from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import Cashflow from '@/charts/CashFlow.vue';
import CashflowV2 from '@/charts/CashFlow_v2.vue';
import FinancialRatioItem from '@/views/FinancialRatioItem.vue';
import DynamicLineChart from '@/charts/DynamicLineChart.vue';
import DynamicColumnChart from '@/charts/DynamicColumnChart.vue';

// tslint:disable-next-line:max-line-length
@Component({components: {Cashflow, CashflowV2, DynamicColumnChart, DynamicLineChart, FinancialRatioItem}})
export default class CardCashFlowNew extends CompanyMixin {
  selected: number = 4;

  get loaded() {
    return this.cashflow && this.balance;
  }

  get hasData() {
    return this.loaded && this.cashflow.sheets.length > 0 && this.balance.sheets.length > 0;
  }

}

